import HttpService from "./http-service";
import MonthPeriod from "@/entities/month-period";
import AsyncPaginatedRequest from "./async-paginated-request";
import { LazyAsyncIter } from "@/iterators";
import { MonthIndex } from "@/typing";
import { Paginated } from "@/pagination";

/**
 * Queries data of entities from the API.
 */
export default class EntitySubmissionExtensionService extends HttpService {
  public deleteExtension(extensionId: number): Promise<void> {
    return this.httpClient.delete(
      `submission-period-extensions/${extensionId}`
    );
  }

  public addExtension(
    entityId: number,
    period: MonthPeriod,
    until: Date
  ): Promise<void> {
    return this.httpClient.post(
      `entities/${entityId}/submission-period-extensions`,
      { period: period.toYMStr(), until: until.toISOString() }
    );
  }

  public getExtensions(
    entityId: number
  ): AsyncIterator<Paginated<SubmissionPeriodExtension>> {
    const reqIter = new AsyncPaginatedRequest<SubmissionPeriodExtensionDTO>(
      "get",
      `entities/${entityId}/submission-period-extensions`,
      undefined,
      undefined,
      this.httpClient
    )[Symbol.asyncIterator]();
    return new LazyAsyncIter(reqIter).map((page) => ({
      ...page,
      pageElements: page.pageElements?.map(fromSubmissionPeriodExtensionDTO),
    }));
  }

  public addExtensionToEntitiesByTypeOrAll(
    period: MonthPeriod,
    until: Date,
    entity_type: number|null
  ): Promise<void> {
    return this.httpClient.post(
      `entities/submission-period-extensions/group`,
      { period: period.toYMStr(), until: until.toISOString(),entity_type }
    );
  }
}

export interface SubmissionPeriodExtensionDTO {
  id: number;
  entity_id: number;
  period_month: MonthIndex;
  period_year: number;
  until: string;
}

export interface SubmissionPeriodExtension {
  id: number;
  period: MonthPeriod;
  until: Date;
  entityId: number;
}

function fromSubmissionPeriodExtensionDTO(
  dto: SubmissionPeriodExtensionDTO
): SubmissionPeriodExtension {
  return {
    id: dto.id,
    period: new MonthPeriod(dto.period_year, dto.period_month),
    until: new Date(Date.parse(dto.until)),
    entityId: dto.entity_id,
  };
}
